"use client";

import * as Sentry from "@sentry/nextjs";
import { useEffect } from "react";

/**
 * Root error boundary. Replaces the whole document when the root layout itself
 * throws, so it has to render its own <html> and <body>.
 */
export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return (
    <html lang="en" className="h-full antialiased">
      <body className="flex min-h-full flex-col items-center justify-center gap-4 bg-white p-8 text-center">
        <h1 className="text-lg font-semibold text-zinc-900">Something went wrong</h1>
        <p className="max-w-md text-sm text-zinc-600">
          The page could not be loaded. The error has been reported.
        </p>
        {error.digest ? (
          <p className="font-mono text-xs text-zinc-400">Reference: {error.digest}</p>
        ) : null}
        <button
          type="button"
          onClick={reset}
          className="rounded border border-zinc-300 bg-zinc-100 px-2.5 py-1 text-[10px] font-semibold text-zinc-700 transition-colors hover:bg-zinc-200"
        >
          Try again
        </button>
      </body>
    </html>
  );
}
